import { format } from 'date-fns'

export const dateLocalTimeFormatter = (date: string, pattern = 'dd MMM yyyy'): string => {
    if (!date) return ''
    const baseDate = date.slice(0, 10)
    const normalizedDate = `${baseDate}T00:00:00`

    if (pattern.includes('H') || pattern.includes('m')) {
        const timeMatch = date.match(/T(\d{2}:\d{2})/)
        return timeMatch ? timeMatch[1] : ''
    }

    return format(new Date(normalizedDate), pattern)
}
